export default "/_next/static/videos/1514d01fd29d7c03c2a83d83adb8b3b6.mp4";